// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgCookingOnGasIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M13 21c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1m-4-1c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1m6 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1m4-13H5c-.55 0-1 .45-1 1s.45 1 1 1h1v7c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V9h1c.55 0 1-.45 1-1s-.45-1-1-1m-3-3h-3V3c0-.55-.45-1-1-1s-1 .45-1 1v1H8c-1.1 0-2 .9-2 2h12c0-1.1-.9-2-2-2" />
  </g>
);
export default SvgCookingOnGasIcon;
SvgCookingOnGasIcon.displayName = 'SvgCookingOnGasIcon';
